var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMesheryLightText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 217.73 26.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 13") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "134.99 4.21 134.99 5.34 134.99 10.69 134.99 17.21 134.99 26.72 160.32 26.72 160.32 21.38 140.33 21.38 140.33 17.21 140.33 16.03 155.69 16.03 155.69 10.69 140.33 10.69 140.33 5.34 160.32 5.34 160.32 0 134.99 0 134.99 4.21",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "37.53 4.21 37.53 5.34 37.53 10.69 37.53 17.21 37.53 26.72 62.87 26.72 62.87 21.38 42.88 21.38 42.88 17.21 42.88 16.03 58.23 16.03 58.23 10.69 42.88 10.69 42.88 5.34 62.87 5.34 62.87 0 37.53 0 37.53 4.21",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.94,19.74a7,7,0,0,1-2.07,4.93,7.24,7.24,0,0,1-2.23,1.5,6.75,6.75,0,0,1-2.72.55h-25V21.09h25a1.33,1.33,0,0,0,1.35-1.35V17.57a1.34,1.34,0,0,0-.39-1,1.3,1.3,0,0,0-1-.39h-18a6.7,6.7,0,0,1-2.71-.55A7.19,7.19,0,0,1,68,14.15a7.07,7.07,0,0,1-1.51-2.25,6.64,6.64,0,0,1-.56-2.71V7a6.84,6.84,0,0,1,.56-2.73A7.19,7.19,0,0,1,70.21.55,6.7,6.7,0,0,1,72.92,0h25V5.66h-25A1.35,1.35,0,0,0,71.57,7V9.19a1.34,1.34,0,0,0,.39,1,1.3,1.3,0,0,0,1,.39h18a6.75,6.75,0,0,1,2.72.55,7.12,7.12,0,0,1,3.74,3.74,6.8,6.8,0,0,1,.56,2.73Z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.64,26.72h-5.09V16.21H106.67V26.72h-5.09V10.55h25V0h5.09ZM106.67,8h-5.09V0h5.09Z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "204.37 9.35 197.69 0 191.01 0 201.7 16.03 201.7 26.72 207.04 26.72 207.04 16.03 217.73 0 211.14 0 204.37 9.35",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.41,5.1h13.71v5.55h-11v5.1h2.53l9.69,11h6.6l-9.69-11H185a4.15,4.15,0,0,0,4.15-4.15V4.15A4.15,4.15,0,0,0,185,0H164.18V26.72h5.34Z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.42,26.72H27.76V7.23a1.54,1.54,0,0,0-.13-.6,1.43,1.43,0,0,0-.34-.5,1.66,1.66,0,0,0-.49-.34,1.62,1.62,0,0,0-.61-.12H0V0H26.19A7,7,0,0,1,29,.57,7.62,7.62,0,0,1,31.3,2.12a7.49,7.49,0,0,1,1.55,2.32,6.93,6.93,0,0,1,.57,2.79Zm-27.75,0H0v-21L5.67,4.11Zm13.86,0H13.86V8.63h5.67Z",
    className: "cls-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMesheryLightText);
export default __webpack_public_path__ + "static/media/meshery-light-text.9cb2a00eec1881085a176fd930ef54d3.svg";
export { ForwardRef as ReactComponent };